import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 2a3 3 0 0 1 3 3v14a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-14a3 3 0 0 1 3 -3zm-3 16h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0 -2","key":"svg-0"}]]

const IconDeviceIpadFilled = createReactComponent('filled', 'device-ipad-filled', 'DeviceIpadFilled', __iconNode);

export default IconDeviceIpadFilled;